import React from 'react';
import WorkoutExerciseConfig from './WorkoutExerciseConfig';
import { useSelector } from 'react-redux';

const WorkoutCard = ({ workout, workoutName, onRemove }) => {
  const { program } = useSelector((state) => { //estado que guarda el objeto grande
      return {program: state.program.data};
  });
  
  const exercises = program.workouts.find(w => w.key === workout.key).exercises;
  return (
    <div
      className="flex-shrink-0 bg-white border-r border-gray-200 flex flex-col h-full"
      style={{ width: `${100/3}%` }}
    >
      <div className="p-4 border-b border-gray-200" style={{ height: '73px' }}>
        <div className="flex justify-between items-start">
          <h4 className="text-sm font-semibold text-gray-800 truncate">
            {workoutName}
          </h4>
          <button 
            onClick={() => onRemove(workout.id, workout.key)}
            className="text-xs px-2 py-1 bg-red-50 text-red-600 rounded hover:bg-red-100 ml-2"
          >
            ×
          </button>
        </div>
      </div>
      
      <div className="flex-1 overflow-y-auto">
        {exercises.length > 0 ? (
          exercises.map((exercise) => (
            <WorkoutExerciseConfig
              key={`${workout.id}-${exercise.key}`}
              exercise={exercise}
              workoutId={workout.id}
            />
          ))
        ) : (
          <div className="p-4 text-center text-gray-500">
            <p className="text-xs">No hay ejercicios</p>
            <p className="text-xs">Agrega ejercicios primero</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkoutCard;